<template>
  <transition name="transition-fade">
    <div class="modal-backdrop">
      <div class="modal-container">
        <div class="modal-dialog" v-scroll-lock="show" @click.self="close()">
          <div class="modal-body">
            <button class="button-reset modal-close-button" type="button" @click="close()">
              <i class="fas fa-times"></i>
            </button>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalBase',
  props: ['show'],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
